export default {
  data() {
    return {
      configs: {
        overall: {
          _hotspotType: 2,
          nonzero: 'Click here to highlight areas to work on',
          zero: 'Click here to highlight areas where you did well',
          headerText:'Vocal Delivery',
        },
        strengthOfOpening: {
          _hotspotType: 0,
          headerText:'Strength of Opening',
        },
        clarity: {
          _hotspotType: 2,
          nonzero: 'Click here to highlight areas to work on',
          zero: 'Click here to highlight areas where you did well',
          headerText:'Clarity',
        },
        convoSwitches: {
          _hotspotType: 1,
          hotspotText: 'Click here to highlight where the dialog went back and forth',
          headerText: 'Meaningful Conversation Switches',
        },
        pace: {
          _hotspotType: 3,
          belowzero: 'Click here to highlight areas where you can speed up',
          zero: 'Click here to highlight areas where your pace was good',
          abovezero: 'Click here to highlight areas where you should slow down',
          headerText:'Pace',
          lowText: 'Too slow',
          highText: 'Too fast',
        },
        pauseToTalk: {
          _hotspotType: 3,
          belowzero: 'Click here to highlight areas where you should think about using a pause to break it up',
          zero: 'Click here to highlight areas where you did good',
          abovezero: 'Click here to highlight areas where your pauses went too long',
          headerText:'Pausing',
          lowText: 'Too little',
          highText: 'Too much',
        },
        talkVsListen: {
          _hotspotType: 0,
          headerText: 'Talking versus Listening',
        },
        upspeak: {
          _hotspotType: 1,
          hotspotText: 'Click here to highlight where you did some upspeak',
          headerText: 'Upspeak',
          lowText: 'None',
          idealText: 'Some',
        },
        questions: {
          _hotspotType: 1,
          hotspotText: 'Click here to view where you asked a question',
          headerText: 'Number of Questions',
          lowText: 'None',
          idealText: 'Some',
        },
        waitTime: {
          _hotspotType: 3,
          belowzero: 'Click here to highlight areas where you waited too little',
          zero: 'Click here to highlight areas where you did good',
          abovezero: 'Click here to highlight areas where you waited too long',
          headerText: 'Average Wait Time',
          lowText: 'Too little',
          highText: 'Too much',
        },
        wordSpotting: {
          headerText:'Word Spotting',
          addHeaders: false,
        },
        varietyVolume: {
          _hotspotType: 3,
          belowzero: 'Click here to highlight areas where you could add variety to improve your score',
          zero: 'Click here to highlight areas where you did best',
          abovezero: 'Click here to highlight areas where you should reduce your variety',
          headerText: 'Variety of Volume',
        },
        varietyPace: {
          _hotspotType: 3,
          belowzero: 'Click here to highlight areas where you could add variety to improve your score',
          zero: 'Click here to highlight areas where you did best',
          abovezero: 'Click here to see some areas where your pace varied the most',
          headerText: 'Variety of Pace',
        },
        varietyPitch: {
          _hotspotType: 3,
          belowzero: 'Click here to highlight areas where you could add variety to improve your score',
          zero: 'Click here to highlight areas where you did best',
          abovezero: 'Click here to highlight areas where you should reduce your variety',
          headerText: 'Variety of Pitch',
        },
        positiveVibes: {
          hotspotText: 'Click on the following positive vibes to see where you scored above average:',
          hotspotMissingText: 'None of your positive vibe scores were extreme in this speech.',
          headerText: 'Positive Vibes',
          activeVibes: [
            'assertive','authentic','captivating', 'clear','confident','energetic', 'organized','personable','persuasive'
          ],
        },
        negativeVibes: {
          hotspotText: 'Click on the following negative vibes to see where you can improve:',
          hotspotMissingText: 'None of your negative vibe scores were extreme in this speech.',
          headerText: 'Negative Vibes',
          activeVibes: [
            'arrogant','nervous', 'boring', 'belligerent','condescending','detached', 'ditsy','confusing','pushy',
            'timid','unapproachable'
          ],
        }
      },

      // Note: We dont actually use these for anything. They're supposed
      // to be used to remove the events when the component goes away
      registeredEvents: [],
    };
  },
  computed: {
    config() {
      const metric = this.metric,
        ideals = this.recording.results.ideals[this.metric];

      let config = this._.cloneDeep(this.configs[metric]);

      if (ideals) {
        // Add min, max and ideals
        config.min = ideals.range.min;
        config.max = ideals.range.max;
        config.idealMin = ideals.range.idealMin;
        config.idealMax = ideals.range.idealMax;
      }

      // Add lowText, idealText, highText
      if (typeof config.lowText === 'undefined') {
        config.lowText = 'Too little';
      }
      if (typeof config.idealText === 'undefined') {
        config.idealText = 'Ideal range';
      }
      if (typeof config.highText === 'undefined') {
        config.highText = 'Too much';
      }

      return config;
    },
    score() {
      return this.results.scores[this.metric];
    },
    results: {
      cache: true,
      get() {
        if (this.recording && this.recording.results && this.recording.results.isConversational) {
          if (!this.recording.results.scores.perSpeaker[this.speakerNum]) return false;

          return {
            algorithm: this.recording.results.algorithm,
            scores: this._.cloneDeep(this.recording.results.scores.perSpeaker[this.speakerNum]),
            tips: this._.cloneDeep(this.recording.results.tips.perSpeaker[this.speakerNum]),
            timestamped: this._.cloneDeep(this.recording.results.timestamped.perSpeaker[this.speakerNum]),
          };
        }
        return this.recording.results;
      }
    },
  },
  methods: {
    // chart helper methods
    _arcPath(cx, cy, rInner, rOuter, angle1, angle2) {
      const angleDiff = angle2 - angle1;

      if (Math.abs(angleDiff) === 360) {
        angle2 -= Math.sign(angleDiff) * 0.01;
      }
      const pInner1 = this._arcPathPoint(cx, cy, rInner, angle1);
      const pInner2 = this._arcPathPoint(cx, cy, rInner, angle2);
      const pOuter1 = this._arcPathPoint(cx, cy, rOuter, angle1);
      const pOuter2 = this._arcPathPoint(cx, cy, rOuter, angle2);
      const largeArc = Math.abs(angleDiff) > 180 ? 1 : 0;
      return `
        M ${pOuter1}
        A ${rOuter} ${rOuter} 0 ${largeArc} 1 ${pOuter2}
        L ${pInner2}
        A ${rInner} ${rInner} 0 ${largeArc} 0 ${pInner1}
        z`;
    },

    // chart helper method
    _arcPathPoint(cx, cy, r, angle) {
      const p = this._arcPoint(cx, cy, r, angle);
      return `${p.x} ${p.y}`;
    },

    // chart helper method
    _arcPoint(cx, cy, r, angle) {
      const alpha = Math.PI * angle/180;
      const x = cx + r * Math.cos(alpha);
      const y = cy - r * Math.sin(alpha);
      return { x, y };
    },

    _getTooltipContentAndEvents(recording, metric, idPrefix='', tipTag='p') {
      const metricConfig = this.configs[metric],
        isVibes = (metric === 'positiveVibes' || metric === 'negativeVibes'),
        hasHotspots = (recording.playbackUrl && isVibes) ?
          true :
          recording.playbackUrl &&
          this.results.timestamped && this.results.timestamped[metric] &&
          this.results.timestamped[metric].hotSpots && this.results.timestamped[metric].hotSpots.length > 0,
        hotspotId = `${idPrefix}HotspotFor${metric}`,
        hotSpotHandler = isVibes ?
          null :
          (event) => {
            event.preventDefault();
            this._showHotspots(metric);
            return false;
          };
      let addHotspots = hasHotspots;

      let tipText = (this.results.tips && this.results.tips[metric]) ?
        this.results.tips[metric].join('<br><br>') : '';

      // Fix to rename "Overall Score" to "Vocal Delivery"
      if (metric === 'overall') {
        tipText = tipText.replace(/overall score/i, 'vocal delivery score');
      }

      let vibesLinks = [],
        vibesLinksHtml = [],
        onShown, onHidden;

      let tipHtml,
        hotSpots = '',
        hotSpotTip;

      if (hasHotspots && metricConfig._hotspotType) {
        if (metricConfig._hotspotType === 1) {
          hotSpotTip = metricConfig.hotspotText;
        } else if (metricConfig._hotspotType === 2) {
          hotSpotTip = (this.results.timestamped[metric].hotSpots[0].spread == 0) ?
            metricConfig.zero : metricConfig.nonzero;
        } else if (metricConfig._hotspotType === 3) {
          if (this.results.timestamped[metric].hotSpots[0].spread < 0) {
            hotSpotTip = metricConfig.belowzero;
          } else if (this.results.timestamped[metric].hotSpots[0].spread == 0) {
            hotSpotTip = metricConfig.zero;
          } else if (this.results.timestamped[metric].hotSpots[0].spread > 0) {
            hotSpotTip = metricConfig.abovezero;
          }
        } else {
          addHotspots = false;
        }
        hotSpots = (addHotspots) ? `<span class="dont-print">
        <a id="${hotspotId}" href="#">
          <span>${hotSpotTip}</span>
        </a>
      </span>` : '';
      }

      // Now we can set the events
      onShown = (addHotspots) ? () => {
        this._addEvent(hotspotId, 'click', hotSpotHandler, false);
      } : function() { };
      onHidden = (addHotspots) ? () => {
        this._removeEvent(hotspotId, 'click', hotSpotHandler);
      } : function() { };

      if (isVibes) {
        metricConfig.activeVibes.forEach((vibeName) => {
          const vibeHasHotspots = this.results.timestamped && this.results.timestamped.vibes && this.results.timestamped.vibes[vibeName] &&
            this.results.timestamped.vibes[vibeName].hotSpots && this.results.timestamped.vibes[vibeName].hotSpots.length > 0;

          if (vibeHasHotspots) {
            const vibeHandler = this._getVibeHotSpotHandler(metric, vibeName);
            const vibeLinkId = `${idPrefix}ShowHotspotFor${vibeName}`;
            const link =
              `<a id="${vibeLinkId}" href="#"><span>${vibeName}</span></a>`;
            vibesLinks.push({vibeName, vibeLinkId, vibeHandler});
            vibesLinksHtml.push(link);
          }
        });
      }

      tipHtml = (tipText) ?
        `<${tipTag}>${tipText}</${tipTag}>${hotSpots}` :
        hotSpots;

      if (isVibes) {
        if (vibesLinks.length) {
          tipHtml = `<span class="dont-print">${metricConfig.hotspotText} ${vibesLinksHtml.join(', ')}</span>`;
          onShown = () => {
            vibesLinks.forEach((vibe) => {
              this._addEvent(vibe.vibeLinkId, 'click', vibe.vibeHandler, false);
            });
          };
          onHidden = () => {
            vibesLinks.forEach((vibe) => {
              this._removeEvent(vibe.vibeLinkId, 'click', vibe.vibeHandler);
            });
          };
        } else {
          tipHtml = `<span class="dont-print">${metricConfig.hotspotMissingText}</span>`;
        }
      }

      return {
        content: tipHtml,
        onShown,
        onHidden,
      };
    },


    showWavesurferVibe(vibes, vibe) {
      const vibeData = (vibes && vibes[vibe]) ? vibes[vibe] : null;

      let data = [],
        lastCoord,
        recordingLength = Math.ceil(this.wavesurfer.getDuration());

      if (!vibeData || !vibeData.series) {
        return false;
      }

      // Pad out the data at the beginning since vibeData.series starts at 5s and not 0s
      for (let i=0; i<vibeData.series[0][0];i+=0.5) {
        data.push({x: i, y: vibeData.series[0][1]});
      }

      vibeData.series.forEach((coord) => {
        data.push({x: coord[0], y: coord[1]});
        lastCoord = coord;
      });

      // Pad out the data at the end since vibeData.series ends too soon
      for (let j=lastCoord[0] + 0.5; j<=recordingLength;j+=0.5) {
        data.push({x: j, y: lastCoord[1]});
      }

      const dataset = {
        label: vibe,
        data,
        xAxisID: 'duration-axis',
        pointRadius: 0,
        borderColor: 'rgba(239, 134, 47, 1)', // TODO: Set colors
        borderWidth: 2
      };

      const initialChart = {
        type: 'line',
        data: {
          datasets: [dataset]
        },
        options: {
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                id: 'duration-axis',
                type: 'linear',
                ticks: {
                  min: 0,
                  max: recordingLength,
                  display: false
                }
              }
            ],
            yAxes: [
              {
                display: false,
                ticks: {
                  min: 0,
                  max: 10,
                }
              }
            ]
          }
        }
      };

      if (document.getElementById('wavesurferZoomFit')) {
        document.getElementById('wavesurferZoomFit').click(); // Reset zoom level
      }

      const addInitialChart = () => {
        // Initial load of data
        this.wavesurfer.addChart({
          chart: initialChart
        });
        this.wavesurfer.wavesurferChartRendered = vibe;
      };

      if (typeof this.wavesurfer.wavesurferChartRendered === 'undefined') {
        addInitialChart();
      } else if (this.wavesurfer.wavesurferChartRendered !== false && this.wavesurfer.wavesurferChartRendered === vibe) {
        // Remove the data when they click the vibe again
        this.wavesurfer.removeDataset(this.wavesurfer.wavesurferChartRendered, true);
        this.wavesurfer.wavesurferChartRendered = 'unloaded';
      } else if (this.wavesurfer.wavesurferChartRendered !== false) {
        // Load a different graph
        if (this.wavesurfer.wavesurferChartRendered !== 'unloaded') {
          this.wavesurfer.removeDataset(this.wavesurfer.wavesurferChartRendered, true);
        }
        this.wavesurfer.addDataset(dataset);
        this.wavesurfer.wavesurferChartRendered = vibe;
      } else {
        addInitialChart();
      }
    },

    _addTooltip(domId, recording, metric) {
      const tipData = this._getTooltipContentAndEvents(recording, metric, domId),
        tippySelector = (metric === 'positiveVibes' || metric === 'negativeVibes') ?
          `#${domId}` : `#${domId} > div`;

      if (!tipData || !tipData.content) {
        return true;
      }

      let tipContainer = document.createElement('DIV');
      tipContainer.className = 'tooltip-content';
      tipContainer.innerHTML = tipData.content;

      // Disable tabindex on all charts
      document.querySelector(tippySelector).tabIndex = -1;

      /* Initialize tooltip */
      const tippyConfig = {
        onShow: (_tippy) => {
          /*
          // Removed this code because it was closing a tip right after it was created,
          // if the user had first clicked to show a region (such as wordspotting word)
          if (window.registeredTippys && window.registeredTippys.length) {
            window.registeredTippys.forEach(
              (tp) => {
                // Delay this by a bit to give open tippys a chance to close
                window.setTimeout(() => {
                  tp.hide();
                }, 100);
              }
            );
          }
           */
          window.registeredTippys = [_tippy];
        },
        multiple: false,
        onShown: tipData.onShown,
        onHidden: tipData.onHidden,
        position: 'right-top',
        html: tipContainer,
        arrow: true,
        animation: 'fade',
        interactive: true,
        delay: [250, 1500],
        duration: 150,
        theme: 'light',
        //trigger: 'mouseenter focus click',
        popperOptions: {
          modifiers: {
            offset: '100, 100',
            flip: {
              behavior: ['right', 'bottom']
            }
          }
        }
      };

      window.tippy(tippySelector, tippyConfig);
    },

    _showHotspots(metric, hotspotKey='') {
      if (!this.wavesurfer) return false;

      let hotSpots;

      if (metric === 'positiveVibes' || metric === 'negativeVibes') {
        metric = 'vibes';
      }

      if (this.results && this.results.timestamped &&
        this.results.timestamped[metric] &&
        this.results.timestamped[metric].hotSpots &&
        this.results.timestamped[metric].hotSpots.length) {
        hotSpots = this.results.timestamped[metric].hotSpots;
      } else if (this.results && this.results.timestamped &&
        this.results.timestamped[metric] && hotspotKey &&
        this.results.timestamped[metric][hotspotKey].hotSpots &&
        this.results.timestamped[metric][hotspotKey].hotSpots &&
        this.results.timestamped[metric][hotspotKey].hotSpots.length) {
        hotSpots = this.results.timestamped[metric][hotspotKey].hotSpots;
      }

      // Always clear any prior hotspot first
      this.wavesurfer.clearRegions();

      // Reset any "Hide Region" links to say "Show Region"
      // TODO: This is such a bad hack. Better to use events/pub/sub
      const links = document.getElementsByClassName('showRegionLink');
      _.forEach(links, (link) => link.innerHTML = 'Show Region');

      const hotspotId = metric + hotspotKey;

      if (window.wavesurferHotspotRendered === hotspotId) {
        // Clicking a hotspot a second time will turn it off
        window.wavesurferHotspotRendered = false;
        return true;
      }

      window.wavesurferHotspotRendered = hotspotId;

      if (hotSpots) {
        _.forEach(hotSpots, (hotSpot) => {
          this.wavesurfer.addRegion({
            //id: `${hotSpot.type}-${index}`, // just so we can css-target them
            start: hotSpot.from,
            end: hotSpot.to,
            drag: false,
            resize: false
          });
        });
      }
    },

    _addEvent(domId, event, handler, registerEvent=true) {
      if (typeof event !== 'string') {
        event.forEach((evt) => {
          this._addEvent(domId, evt, handler, registerEvent);
        });
      }
      if (!document.getElementById(domId)) {
        return false;
      }
      document.getElementById(domId).addEventListener(event, handler);
      if (registerEvent) {
        this.registeredEvents.push({
          domId,
          event,
          handler
        });
      }
    },

    _getVibeHotSpotHandler(metric, vibeName) {
      const _vibeName = vibeName;
      const _metric = metric;
      return (event) => {
        event.preventDefault();
        this._showHotspots(_metric, _vibeName);
        return false;
      };
    },

    _removeEvent(domId, event, handler) {
      if (document.getElementById(domId)) {
        document.getElementById(domId).removeEventListener(event, handler);
      }
    },

  },
};
